import React from 'react'

const SubProducts = ({ productInfo }) => {
    return (
        <div className='product_info_list'>
            {/* <h2>Package Name</h2>
            <h3 class="serviceName">{productInfo?.product_name}</h3> */}
            <p>
                Based on your requirements, we recommend the following product(s):
            </p>
            <ol>
                {productInfo?.sub_products?.length > 0 && productInfo?.sub_products?.map((item, index) => (
                    <li>{item?.sub_prod_name} {item?.sub_prod_base_quantity && `X ${item?.sub_prod_base_quantity}`}</li>
                ))}
            </ol>
        </div>
    )
}

export default SubProducts